export default __webpack_public_path__ + "static/media/user6.6a89f389.jpg";